import { NgModule } from '@angular/core';
import { Routes, RouterModule } from '@angular/router';

import { ServiceSheetPage } from './service-sheet.page';

const routes: Routes = [
  {
    path: '',
    component: ServiceSheetPage
  }
];

@NgModule({
  imports: [RouterModule.forChild(routes)],
  exports: [RouterModule],
})
export class ServiceSheetPageRoutingModule {}
